import styled from 'styled-components';
import { DatePicker as MantineDatePicker } from '@mantine/dates';
import { smRegular, xsRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';

export const DatePicker = styled(MantineDatePicker<'range'>).attrs({
  type: 'range',
})`
  & .mantine-DatePicker-levelsGroup > div {
    min-width: 282px;
  }

  & .mantine-DatePicker-calendarHeader {
    max-width: unset;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2px;

    margin: 0 4px 8px 4px;
  }

  & .mantine-DatePicker-monthsList,
  & .mantine-DatePicker-yearsList {
    display: flex;
    justify-content: center;
  }

  & .mantine-DatePicker-calendarHeaderLevel {
    height: 28px;
    ${xsRegular}
    color: ${themeColor('textPrimary')};
    &:hover {
      background: ${themeColor('buttonBackgroundHover')};
    }
  }

  & .mantine-DatePicker-calendarHeaderControl {
    box-sizing: content-box;
    display: flex;
    width: 16px;
    height: 16px;
    padding: 6px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 6px;
    border: 1px solid ${themeColor('strokePrimary')};
    background: ${themeColor('backgroundLight')};
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);

    color: ${themeColor('textPrimary')};
    &:hover:not(:disabled) {
      background: ${themeColor('buttonBackgroundHover')};
    }

    & svg {
      width: 100% !important;
      height: 100% !important;
    }
  }

  & .mantine-UnstyledButton-root {
    ${smRegular}
    &:hover:not(:disabled) {
      background: ${themeColor('buttonBackgroundHover')};
    }
  }

  & .mantine-DatePicker-weekday {
    ${xsRegular}
    color: ${themeColor('headerGray')};

    padding: 16px 0;
  }

  & .mantine-DatePicker-day {
    color: ${themeColor('textPrimary')};

    box-sizing: content-box;
    width: 28px;
    height: 28px;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid transparent;

    &[data-in-range='true'],
    &[data-selected='true'],
    &:hover {
      border-radius: 8px;
      border: 1px solid ${themeColor('turquoiseQuaternary')};
      background: ${themeColor('turquoiseQuaternary')};
      color: ${themeColor('backgroundLight')};
      color: ${themeColor('white')};
    }
    &[data-first-in-range='true'],
    &[data-last-in-range='true'] {
      border: 1px solid ${themeColor('turquoise')};
    }

    &[data-disabled='true'] {
      background: unset;
      border: unset;
    }

    &[data-outside='true'] {
      color: ${themeColor('textTertiary')};
      opacity: unset;
    }
    &.marked-date {
      color: ${themeColor('purpleHome')};
    }
  }
  padding: 0;

  & .mantine-DatePicker-monthRow > td:not(:last-child) {
    padding-right: 2px;
  }

  & .mantine-DatePicker-monthRow:not(:last-child) > td {
    padding-bottom: 2px;
  }
`;
